var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"authorith-nothing"},[_c('img',{staticClass:"no-authority",attrs:{"src":require("../../../assets/no-authority.png")}}),_c('p',{staticClass:"tips"},[_vm._v("无此权限，请联系管理员添加")])])
}]

export { render, staticRenderFns }